/**
 * Currency formatting utilities for Fisher TMS
 */

/**
 * Format a value as USD currency with $ prefix
 * @param value - The value to format (string or number)
 * @returns Formatted currency string (e.g., "$ 1,234.56") or '--' if invalid
 */
export function formatCurrency(value: string | number): string {
  if (value === null || value === undefined || value === '') return '--';
  const num = Number(value);
  if (isNaN(num)) return '--';
  return '$ ' + num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
